import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=5d63ec2b&scoped=true"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=5d63ec2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63ec2b",
  null
  
)

export default component.exports